import { getTableSelectColumn as y } from "./components/GetTableSelectColumn/getTableSelectColumn.js";
const g = (s, u, e) => s ? u.flatMap(
  (c) => {
    var r;
    return (r = c.columns) == null ? void 0 : r.flatMap((l, a) => ({
      ...l,
      display: !e.includes(l.accessorKey ?? ""),
      id: l.accessorKey,
      key: l.accessorKey,
      label: l.accessorKey === "actions" ? "Actions" : l.header,
      index: a
    }));
  }
) : u.map((c, r) => {
  const l = c.accessorKey;
  return {
    ...c,
    id: l,
    display: !e.includes(l),
    key: l,
    label: l === "actions" ? "Actions" : c.header,
    index: r
  };
}), i = (s, u, e, c) => {
  let r = s;
  const l = r.some(
    (a) => {
      var t;
      return (t = a.columns) == null ? void 0 : t.length;
    }
  );
  return u.length > 0 && (l ? r = r.map((a) => {
    var d;
    const t = ((d = a.columns) == null ? void 0 : d.filter((b) => !u.includes(String(b.accessorKey)))) ?? [];
    return t.length > 0 ? { ...a, columns: t } : null;
  }).filter((a) => a !== null) : r = r.filter(
    (a) => !u.includes(String(a.accessorKey))
  )), c && (r = [
    y(l, (a) => {
      var t, d, b, f, n;
      return {
        disabled: (((d = (t = e == null ? void 0 : e.enableRowSelection) == null ? void 0 : t.call(e, a)) == null ? void 0 : d.disabled) || ((b = e == null ? void 0 : e.isDisabledRow) == null ? void 0 : b.call(e, a))) ?? !1,
        disabledTooltip: (n = (f = e == null ? void 0 : e.enableRowSelection) == null ? void 0 : f.call(e, a)) == null ? void 0 : n.disabledTooltip
      };
    }),
    ...r
  ]), r;
}, K = (s) => s.length ? s.reduce((e, c) => (e[c] = !0, e), {}) : {};
export {
  K as getDefaultSelectedRows,
  g as getFlattedColumns,
  i as getTableColumns
};
//# sourceMappingURL=helper.js.map
